import { render, staticRenderFns } from "./RecentKBView.vue?vue&type=template&id=50f87f00&scoped=true"
import script from "./RecentKBView.vue?vue&type=script&lang=js"
export * from "./RecentKBView.vue?vue&type=script&lang=js"
import style0 from "./RecentKBView.vue?vue&type=style&index=0&id=50f87f00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f87f00",
  null
  
)

export default component.exports